import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonHeadingUp
  from 'components/atoms/Editors/EditorMenuButtonHeadingUp/EditorMenuButtonHeadingUp.styles';
import {useRichTextEditorContext, getAttributesForEachSelected} from 'mui-tiptap';
import TextIncrease from '@mui/icons-material/TextIncrease';

const EditorMenuButtonHeadingUp = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonHeadingUp');

  const editor = useRichTextEditorContext();

  const enabledHeadingLevels = useMemo(() => {
    const headingExtension = editor?.extensionManager.extensions.find((extension) => extension.name === 'heading');
    return headingExtension?.options?.levels ?? [];
  }, [editor]);

  let nextLevel, hasNextLevel;
  if (editor?.isActive('heading')) {
    const currentNodeHeadingAttributes = getAttributesForEachSelected(
      editor.state,
      'heading'
    );
    const currentNodeLevels = currentNodeHeadingAttributes.map((attrs) => attrs.level);
    const numCurrentNodeLevels = new Set(currentNodeLevels).size;
    if (numCurrentNodeLevels === 1) {
      nextLevel = currentNodeHeadingAttributes[0].level - 1;
    }
  } else if (enabledHeadingLevels.length > 0) {
    nextLevel = enabledHeadingLevels[enabledHeadingLevels.length - 1];
  }

  hasNextLevel = enabledHeadingLevels.includes(nextLevel);

  return <StyledEditorMenuButtonHeadingUp buttonRef={ref} {...innerProps}
                                          tooltipLabel="Heading up"
                                          tooltipShortcutKeys={['mod', 'Alt', 'Arrow Up']}
                                          onClick={() => editor?.chain().increaseHeading().focus().run()}
                                          disabled={!editor?.isEditable || !hasNextLevel}
                                          IconComponent={TextIncrease}/>
});

EditorMenuButtonHeadingUp.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonHeadingUp;
